import {observable, action} from 'mobx';
import api from '../utils/api';
import { parseApiListResponse } from '../utils/apiResponse';
import ProductStore from './ProductStore';

/**
 * the class to map the student object
 */
class Student {

    @observable classIdSf;
    @observable code;
    @observable cpf;
    @observable createdAt;
    @observable date;
    @observable deletedAt;
    @observable email;
    @observable expiration;
    @observable firstName;
    @observable id;
    @observable lastName;
    @observable level;
    @observable startDate;
    @observable unitIdSf;
    @observable updatedAt;
    @observable preparation;
    @observable engagement;

    constructor(student) {
        this.classIdSf = student.classIdSf;
        this.code = student.code;
        this.cpf = student.cpf;
        this.createdAt = student.createdAt;
        this.date = student.date;
        this.deletedAt = student.deletedAt;
        this.email = student.email;
        this.expiration = student.expiration;
        this.firstName = student.firstName;
        this.id = student.id;
        this.lastName = student.lastName;
        this.level = student.level;
        this.startDate = student.startDate;
        this.unitIdSf = student.unitIdSf;
        this.updatedAt = student.updatedAt;
        this.preparation = student.preparation;
        this.attendance = student.attendance;
        this.engagement = student.engagement;
        this.replacement = student.replacement;

    }
}

class SchoolStore {
    

    @observable groupProgress = 0; // this is used to calculate the group progress in getFrequencies() method
    @observable units = []; // array of units get in getUnits() method
    @observable classes = []; // array of classes get in getClassesBySchool() method
    @observable lessons = []; // array of lessons get in getLessonsByCLass() method
    @observable students = []; // array of students get in getStudents() method
    @observable studentsEngagement = []; // array of students get in getStudents() method
    @observable showStudents = true;
    @observable engagements = []; // array of engagements reports of student get in getEngagementReport() method
    @observable isLoading = false; // to control the request
    @observable isEngagement = false; // is engagement
    @observable isDetail = false; // is detail
    @observable noResult = false; // has no result
    @observable isSearch = false; // has no result
    @observable msgAttendance = "";
    @observable classesLoadError = "";

    //Options do Select
    @observable schoolSelected  = null;
    @observable classSelected   = null;
    @observable lessonSelected  = null;

    //Objetos Selecionados
    @observable currentClass = {};

    constructor() {
        this.setupProductListener();
    }

    setupProductListener() {
        // Reset data when product changes
        let lastProduct = ProductStore.selectedProduct;
        setInterval(() => {
            if (lastProduct !== ProductStore.selectedProduct) {
                lastProduct = ProductStore.selectedProduct;
                this.resetData();
            }
        }, 100);
    }

    @action
    resetData() {
        this.classes = [];
        this.lessons = [];
        this.students = [];
        this.studentsEngagement = [];
        this.engagements = [];
        this.schoolSelected = null;
        this.classSelected = null;
        this.lessonSelected = null;
        this.currentClass = {};
        this.groupProgress = 0;
        this.showStudents = true;
        this.classesLoadError = "";
    }

    _applyClassesList(classes) {
        this.classes = classes.sort(function (a, b) {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
        }).filter(function (i) {
            return !i.name.startsWith("IN");
        });
    }

    _handleClassesApiResponse(response) {
        const parsed = parseApiListResponse(response);

        if (!parsed.ok) {
            this.classes = [];
            this.lessons = [];
            this.classesLoadError = parsed.message;
            this.isLoading = false;
            return;
        }

        this.classesLoadError = "";
        this._applyClassesList(parsed.data);
        this.isLoading = false;
    }

    _handleClassesApiFailure() {
        this.classes = [];
        this.lessons = [];
        this.classesLoadError =
            'Não foi possível carregar as turmas. Verifique sua conexão e tente novamente.';
        this.isLoading = false;
    }

    /*
        ############################
        # Busca Units de um User  #
        ###########################
    */
    
    /*
    @action
    async getUnits(params) {
        if (params['id_sf_teacher'] === -1) {
            this.units = [];
            this.lessons = [];
            this.classes = [];
            return;
        }

        this.isLoading = true;

        return await api.call(`/units/teacher/${params['id_sf_teacher']}`, "GET")
            .then(
                response => {
                    this.isLoading = false;
                    this.units = response;
                }
            )
    } 
    */

    /*
        ##############################
        # Busca Classes de uma Unit  #
        ##############################
    */
    @action
    getClassesBySchool(unit_id,user) {

        if (unit_id === -1) {
            this.classes = [];
            this.lessons = [];
            return;
        }

        this.isLoading = true;
        this.classesLoadError = "";

        //Coordenador
        if(user.profile === "Coordenador" || user.profile === "Administrador"){

            //Busca Todas as Classes 
            return api.call(`/classes/unit/${unit_id}`, "GET")
            .then(response => this._handleClassesApiResponse(response))
            .catch(() => this._handleClassesApiFailure());
        }

        //Professor
        else if(user.profile === "Professor"){

            //Busca Somente as Classes por IDSalesforce do Professor
            return api.call(`/classes/unit/${unit_id}?teacher_email=${user.email}`, "GET")
            .then(response => this._handleClassesApiResponse(response))
            .catch(() => this._handleClassesApiFailure());
        }

        this.isLoading = false;
    }

    /*
        ###############################
        # Busca Lessons de uma Class  #
        ###############################
    */
    @action
    getLessonsByCLass(classroom_id) {

        if (classroom_id === -1) {
            this.lessons = [];
            return;
        }

        //this.isLoading = true;

        return api.call(`/calendar-items/class/${classroom_id}?order=DESC`, "GET")
            .then(
                response => {
                    const parsed = parseApiListResponse(response);
                    this.lessons = parsed.ok ? parsed.data : [];
                }
            )
            .catch(() => {
                this.lessons = [];
            });
    }


    /*
        ###################################
        # Busca as Lessons de um Student  #
        ###################################
    */
    @action
    async getLessonsByStudent(student_id,student_level) {

        if (student_id === -1) {
            this.lessons = [];
            return;
        }

        this.isLoading = true;

        return await api.call(`/engagement-reports/index/${student_id}/${student_level}`, "GET")
            .then(
                response => {
                    this.isLoading = false;
                    this.lessons = response.data[0].lessons;
                }
            )
    }

    /*
        ###################################
        # Busca os Students de uma Class  #
        ###################################
    */

    getStudentsbyClass(classroom_id){

        if (classroom_id === -1) {
            this.studentsEngagement = [];
            return;
        }

        this.isLoading = true;
        
        return api.call(`/students/class/${classroom_id}`, "GET")
            .then(
                response => {

                    if(response.length > 0) {
                        this.students = response.map((item, index) => {
                            return new Student({
                                classIdSf : item.class_id_sf,
                                code : item.code,
                                cpf : item.cpf,
                                createdAt : item.created_at,
                                date : item.date,
                                deletedAt : item.deleted_at,
                                email : item.email,
                                expiration : item.expiration,
                                firstName : item.firstname,
                                id : item.id,
                                lastName : item.lastname,
                                level : item.level,
                                startDate : item.start_date,
                                unitIdSf : item.unit_id_sf,
                                updatedAt : item.updated_at,
                                preparation: "",
                                engagement: "",
                            });
                        });

                        this.isLoading = false;
                        
                    } else {
                        this.students = [];
                        this.studentsEngagement = [];
                        this.isLoading = false;
                    }

                    //Valor Duplicado pois Engagament Report exibe essa Listagem
                    this.studentsEngagement = this.students;

                }
            );
    }

    /*
        ####################################
        # Busca os Students de uma Lesson  #
        ####################################
    */
    @action
    async getStudentsByLesson(calendar_id) {

        //Caso Classrom ID inválida
        if (this.currentClass.id_sf === -1) {
            this.studentsLesson = [];
            return;
        }

        //Inicia Loader
        this.isLoading = true;
        
        try{

            //Chamada API
            return await api.call(`/proxy/students-frequences`, "GET", {
                id_atividade_calendario: calendar_id,
                id_turma: this.currentClass.id_sf,
                no_cache: 1
            })
            .then(
                response => {

                    if(response.length > 0) {

                        //Declara Counter do GroupProgress
                        let sumGroupProgress = 0;

                        //Loop em Students retornados, registrando na Store
                        this.students = response.map((item) => {

                            //Contagem do GroupProgress
                            sumGroupProgress += +item.preparation;

                            //Attendence
                            let attendance;
                            if( item.present ) {
                                if( item.late ) {
                                    attendance = 'atrasado';
                                } else {
                                    attendance = 'presente';
                                }
                            } else {
                                attendance = 'faltou';
                            }

                            //Instancia novo Estudante
                            return new Student({
                                updatedAt : item.UpdatedAt,
                                classIdSf : item.classIdSf,
                                code : item.code,
                                cpf : item.cpf,
                                createdAt : item.createdAt,
                                date : item.date,
                                deletedAt : item.deleteAt,
                                email : item.email,
                                engagement: "",
                                expiration : item.expiration,
                                firstName : item.firstName,
                                lastName : item.lastName,
                                level : item.level,
                                photo: item.photo,
                                preparation: item.preparation,
                                startDate : item.startDate,
                                id : item.student_id,
                                unitIdSf : item.unitIdSf,
                                attendance: attendance,
                                replacement: item.replacement
                            });
                        });

                        //Seta GroupProgress na Store
                        this.groupProgress = 0;
                        if (sumGroupProgress !== 0) {
                            this.groupProgress = parseFloat(sumGroupProgress / response.length).toFixed(2);
                        }

                        //Encerra Loader
                        this.isLoading = false;

                    } 
                    else {

                        //Seta array vazio de Students na Store
                        this.students = [];

                        //Seta GrouProgress vazio de Students na Store
                        this.groupProgress = 0;

                        //Encerra Loader
                        this.isLoading = false;
                    }
                }
            );
        }
        catch(err) {

            //Seta array vazio de Students na Store
            this.students = [];

            //Seta GrouProgress vazio de Students na Store
            this.groupProgress = 0;

            //Encerra Loader
            this.isLoading = false;
        }
    }

    /*
        ########################################################
        # Busca as Lessons + Engagament Reports de um Student  #
        ########################################################
    */
    @action
    async getEngagementReport(id_sf) {
        this.isLoading = true;

        return await api.call(`/users/`+id_sf+`/engagement-report`, "GET").then(
            response => {

                this.engagements = response;

                this.isLoading = false;
            }
        )
    }

    /*
        ####################
        # Busca um Student #
        ####################
    */
    @action
    async searchStudent(name,unit_id) {
        this.isSearch = true;
        this.isLoading = true;

        let body = {};
        if (isNaN(name)) {
            body = {
                "unit_id" : unit_id,
                "name" : name
            };
        } else {    
            body = {
                "unit_id" : unit_id,
                "cpf" : name
            };
        }


        return await api.call(`/users/search`, "POST", body).then(

            response => {
                this.students = response.map((item, index) => {
                    let student = new Student({
                        classIdSf : item.classroom,
                        cpf: item.cpf,
                        email : item.email,
                        level : item.level,
                        startDate : item.start_date,
                    });

                    student.fullname = item.fullname;
                    student.photo = item.avatarUrl;
                    student.className = item.classroom_name;
                    student.lastLogin = item.lastLogin;
                    student.schoolName = item.school_name;
                    student.modules = item.modules;

                    return student;
                });
            },
            error => {
                return false;
                this.isLoading = false;
            }
        );

    }

    /*
    ####################
    # Marca presença #
    ####################
    */
    @action
    async checkAttendance(student_id, unit_id) {
        this.isLoading = true;

        let data = {
            "unit": unit_id,
            "contact_id": student_id
        };

        return await api.callAttendance(`https://f.escolaconquer.com.br/presence?unit=${unit_id}&contact_id=${student_id}&flag=Conquer`, data)
            .then(
                response => {
                    if(response.success){
                        this.msgAttendance = response.msg;
                        document.querySelector(".error-msg-attendance").style.color = "lightgreen";

                        for (let i = 0; i < this.students.length; i++) {
                            if(student_id === this.students[i].id){
                                if(response.late){
                                    this.students[i].attendance = "late";
                                }else{
                                    this.students[i].attendance = "present";
                                }
                            }
                        }
                    } else{
                        this.msgAttendance = response.msg;
                        document.querySelector(".error-msg-attendance").style.color = "red";
                    }

                    this.isLoading = false;
                }).catch(error => {
                console.log(error);
                this.msgAttendance = error;
                document.querySelector(".error-msg-attendance").style.color = "red";
                this.isLoading = false;
                return error;
            });
    }

    @action
    getLessonsByCLassAndDay(unit_id, teacher_id) {

        if (unit_id === -1 || teacher_id === -1) {
            this.lessons = [];
            return;
        }

        return api.call(`/rocket/available-lessons-today?unit_id=${unit_id}&teacher_id=${teacher_id}`, "GET")
            .then(
                response => {
                    this.lessons = response.data;
                }
            )
    }

}

export default new SchoolStore();


// WEBPACK FOOTER //
// ./src/stores/SchoolStore.js